import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const putIsRead = (id) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.MY_QUERIES.PUT_IS_READ(id),
  );
};

export default putIsRead;
